import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { JSONSchema6 } from 'json-schema';

export const newFormSchema: JSONSchema6 = {
  title: 'Form Upload',
  type: 'object',
  required: ['name', 'formFile'],
  properties: {
    name: { type: 'string', title: 'Name' },
    formFile: { type: 'string', title: 'PDF', format: 'data-url' },
    dealer_id: { type: 'string' },
  },
};

export const step1Schema: JSONSchema6 = {
  title: 'Form Upload',
  type: 'object',
  required: ['name', 'dealer_id'],
  properties: {
    name: { type: 'string', title: 'Name' },
    formFile: { type: 'string', title: 'PDF', format: 'data-url' },
    url: { type: 'string', title: 'URL' },
    dealer_id: { type: 'string' },
  },
};

function LinkWidget(props: { value: string }) {
  return (
    <Link
      className="btn btn-secondary"
      to={{ pathname: `${props.value}` }}
      target="_blank"
    >
      PDF file
    </Link>
  );
}

LinkWidget.propTypes = {
  value: PropTypes.string,
};

export const uiSchema = {
  dealer_id: { 'ui:widget': 'hidden' },
  url: { 'ui:widget': LinkWidget },
};
